import script from "./whGOnceImg5.vue?vue&type=script&setup=true&lang=js"
export * from "./whGOnceImg5.vue?vue&type=script&setup=true&lang=js"

import "./whGOnceImg5.vue?vue&type=style&index=0&id=e6b67e7c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6b67e7c"]])

export default __exports__